import PageHero from '@/components/sections/shared/PageHero'
import { useData } from '@/hooks/useLocale'

/** A legal document's photo hero, with its last-updated and draft badges. */
export default function LegalHeroSection({ doc }) {
  const { LEGAL_META } = useData()

  return (
    <PageHero eyebrow={LEGAL_META.eyebrow} title={doc.title} text={doc.intro}>
      <div className="flex flex-wrap items-center gap-2.5 pt-1.5 text-[13px]">
        <span className="flex h-[30px] items-center rounded-full bg-white/12 px-3">
          {LEGAL_META.updated}
        </span>
        {LEGAL_META.draft && (
          <span className="flex h-[30px] items-center rounded-full bg-[#fff3e6] px-3 font-medium text-[#b36a1a]">
            {LEGAL_META.draft}
          </span>
        )}
      </div>
    </PageHero>
  )
}
